export const sampleFellows = [
  {
    id: "f1",
    name: "Felix Onyango",
    username: "@felix",
    university: "Kaimosi Friends University",
    faculty: "BSc Geography",
    mutualCount: 18,
    isVerified: true,
    isOnline: true,
    category: "My Fellows",
    avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=250&q=80",
    bio: "Building Fellora for all Fellows worldwide. Passionate about geography, tech, and community.",
  },
  {
    id: "f2",
    name: "Sarah Wanjiru",
    username: "@sarahw",
    university: "Kaimosi Friends University",
    faculty: "BSc Computer Science",
    mutualCount: 24,
    isVerified: true,
    isOnline: true,
    category: "Online Fellows",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=250&q=80",
    bio: "Tech enthusiast & Fellow developer.",
  },
  {
    id: "f3",
    name: "David Ochieng",
    username: "@david_och",
    university: "University of Nairobi",
    faculty: "School of Engineering",
    mutualCount: 12,
    isVerified: false,
    isOnline: true,
    category: "Suggested Fellows",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=250&q=80",
    bio: "Civil Engineering Fellow | Structural design fan.",
  },
  {
    id: "f4",
    name: "Amina Hassan",
    username: "@amina_h",
    university: "Kenyatta University",
    faculty: "School of Medicine",
    mutualCount: 31,
    isVerified: true,
    isOnline: false,
    category: "University Fellows",
    avatar: "https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=250&q=80",
    bio: "Medical Student & Academic Fellow.",
  },
  {
    id: "f5",
    name: "Brian Kipkorir",
    username: "@bkipkorir",
    university: "Moi University",
    faculty: "School of Business & Economics",
    mutualCount: 9,
    isVerified: false,
    isOnline: true,
    category: "Discover Fellows",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=250&q=80",
    bio: "Finance & Startup Fellow.",
  },
  {
    id: "f6",
    name: "Grace Muthoni",
    username: "@muthoni_g",
    university: "Kaimosi Friends University",
    faculty: "BSc Geography",
    mutualCount: 15,
    isVerified: true,
    isOnline: true,
    category: "Faculty/Class Fellows",
    avatar: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=250&q=80",
    bio: "GIS & Environmental Fellow.",
  },
  {
    id: "f7",
    name: "Emmanuel Koech",
    username: "@ekoech",
    university: "Strathmore University",
    faculty: "Faculty of IT",
    mutualCount: 42,
    isVerified: true,
    isOnline: true,
    category: "Alumni Fellows",
    avatar: "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?auto=format&fit=crop&w=250&q=80",
    bio: "Software Engineer Alumni Fellow.",
  },
  {
    id: "f8",
    name: "Joy Chebet",
    username: "@chebet_j",
    university: "Kaimosi Friends University",
    faculty: "Department of Arts & Humanities",
    mutualCount: 8,
    isVerified: false,
    isOnline: false,
    category: "Friend Requests",
    avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=250&q=80",
    bio: "Literature & Creative Arts Fellow.",
  },
];
